function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var hydro2 = {
  surface: {
    main: '#FFFFFF',
    dark: '#eef0f1',
    //TODO: Consider renaming
    inverted: '#002b45'
  },
  primary: {
    light: '#345370',
    main: '#002b45',
    dark: '#00001e'
  },
  secondary: {
    light: '#bbddf3',
    main: '#49a2df',
    dark: '#1874bc'
  },
  status: {
    success: '#4caf50',
    warning: '#ff9800',
    alert: '#be1e2d'
  },
  text: {
    dark: {
      primary: '#4d4e4c',
      secondary: 'rgba(77, 78, 76, 0.7)',
      disabled: 'rgba(77, 78, 76, 0.3)'
    },
    primary: {
      primary: '#002b45',
      secondary: 'rgba(0,43,69, 0.7)',
      disabled: 'rgba(0,43,69, 0.3)'
    },
    secondary: {
      primary: '#49a2df',
      secondary: 'rgba(73,162,223,0.7)',
      disabled: 'rgba(73,162,223,0.3)'
    },
    light: {
      primary: '#ffffff',
      secondary: 'rgba(255, 255, 255, 0.7)',
      disabled: 'rgba(255, 255, 255, 0.3)'
    }
  }
};
var surface = hydro2.surface,
    primary = hydro2.primary,
    secondary = hydro2.secondary,
    text = hydro2.text,
    status = hydro2.status;
var legacyColorPalette = {
  surface: {
    backgroundGrey: surface.dark,
    // backgroundGrey.primary
    white: surface.main,
    // white.primary
    whiteHover: surface.dark // backgroundGrey.hover

  },
  "static": {
    textGrey: text.dark.primary,
    // textGrey.primary
    textMedium: text.dark.secondary,
    // textGrey.medium
    textLight: text.dark.disabled,
    // textGrey.light
    groupBlue: primary.main,
    // groupBlue.primary
    groupMedium: primary.light,
    // groupBlue.medium
    groupLight: primary.light // groupBlue.light

  },
  interaction: {
    linkBlue: secondary.main,
    // linkBlue.primary
    linkHover: secondary.dark,
    // actionBlue.hover
    actionBlue: secondary.main,
    // actionBlue.primary
    actionHover: secondary.dark,
    // actionBlue.hover
    actionMedium: secondary.light,
    // actionBlue.medium
    actionLight: secondary.light,
    primaryOrange: '#ed8800',
    // primaryOrange.primary
    primaryHover: '#e16900',
    // primaryOrange.hover
    uiEnabled: text.dark.secondary,
    uiDisabled: text.dark.disabled
  },
  status: {
    yesGreen: status.success,
    // new green
    cautionAmber: status.warning,
    // new yellow
    noRed: status.alert // noRed.primary

  }
};

var legacyColors = _objectSpread({}, legacyColorPalette.surface, {}, legacyColorPalette["static"], {}, legacyColorPalette.interaction, {}, legacyColorPalette.status);

export { hydro2, legacyColorPalette, legacyColors }; // TODO: Deprecate 'colors' and 'colorPalette' exports

export { legacyColors as colors };
export { legacyColorPalette as colorPalette };